export const INVOICE_TYPE_INVOICE = 'invoice'

export const INVOICE_TYPE_CREDIT = 'credit'

export const INVOICE_TYPE_INVOICE_CORRECTION = 'invoice_correction'

export const INVOICE_TYPE_PREPAYMENT = 'prepayment'

export const TYPE_SET = 'type_set'

export const TYPE_TREATMENT = 'type_treatment'

export const PAYMENT_METHOD_CREDIT_CARD = 'credit_card'

export const PAYMENT_METHOD_PREPAYMENT = 'prepayment'

export const PAYMENT_METHOD_SEPA = 'sepa'




// WEBPACK FOOTER //
// ./src/constant/invoice-constant.js